const FIVE_MINUTES = 5 * 60 * 1000;
const ONE_MINUTE = 60 * 1000;
const THIRTY_SECONDS = 30 * 1000;

export const INFINITE_CACHING = { cacheTime: Infinity, staleTime: Infinity };
export const LIMITED_CACHING = { cacheTime: FIVE_MINUTES, staleTime: FIVE_MINUTES };
export const SHORT_CACHING = { cacheTime: ONE_MINUTE, staleTime: ONE_MINUTE };
export const THIRTY_SECONDS_CACHING = { cacheTime: THIRTY_SECONDS, staleTime: THIRTY_SECONDS };
export const NO_CACHING = { cacheTime: 0, staleTime: 0 };
